import { CellModel, ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { GridEditorAdapter, GridEditorOptions } from "@reporting/rp-app-host";
import { AccountingRights } from "@reporting/rp-types/core";
import { DbProcess } from "@reporting/rp-types/server";

export class ProcessGridAdapter extends GridEditorAdapter {

	private _columns?: ColumnSource[];

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;

		this._columns = [{
			data: 'controls',
			t: 'a',
			w: 5 + 20 * 2,
			content: [...rp.userProvider.hasRight(AccountingRights.DWHWrite) ? [{
				action: 'kill',
				title: msg('Kill'),
				icon: 'xmark',
				color: ColorTypes.Red,
			}] : [], {
				action: 'sql',
				title: msg('Show SQL'),
				icon: 'code',
				color: ColorTypes.Blue,
			}],
			filter: false,
			sorting: false,
		}, {
			data: 'spid',
			header: 'SPID',
			t: 'n',
			z: '0',
			w: 80,
		}, {
			data: 'job_name',
			header: msg('Job'),
			t: 't',
			w: 200,
		}, {
			data: 'step',
			header: msg('Step'),
			t: 'n',
			z: '0',
			w: 60,
		}, {
			data: 'status',
			header: msg('Status'),
			t: 't',
			w: 90,
		}, {
			data: 'host_name',
			header: msg('Host'),
			t: 't',
			w: 120,
		}, {
			data: 'db_name',
			header: msg('DB'),
			t: 't',
			w: 120,
		}, {
			data: 'blk_by',
			header: msg('Blk by'),
			t: 't',
			w: 80,
		}, {
			data: 'command',
			header: msg('Command'),
			t: 't',
			w: 120,
		}, {
			data: 'cpu_time',
			header: msg('CPU time'),
			t: 'n',
			z: '0',
			w: 100,
		}, {
			data: 'disk_io',
			header: msg('Disk IO'),
			t: 'n',
			z: '0',
			w: 100,
		}, {
			data: 'last_batch',
			header: msg('Last batch'),
			t: 't',
			w: 150,
		}];
		return this._columns;
	}

	async getRows(_filters?: RequestFilters): Promise<RowSource[]> {
		const processes = await rp.ms('server').get<DbProcess[]>('processes');
		return (processes ?? []).map(data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			rowNumbers: true,
			filters: true,
			columnSorting: true,
			pageSize: null,
			editable: false,
			toolbar: {
				save: { enabled: false },
				discard: { enabled: false },
				new: { enabled: false },
				autoUpdate: { enabled: true },
			},
		});
	}

	async onAction(action: string, cell: CellModel): Promise<void> {
		const data = cell?.row?.data as DbProcess | undefined;
		const spid = data?.spid;
		if (spid == null) return;
		switch (action) {
			case 'kill':
				const command = await rp.host.openMenu({
					content: 'yes_no',
					text: msg('Are you sure?')
				});
				if (command?.id == 'Y') {
					await rp.ms('server').get(`abort/${spid}`);
					this.editor?.refresh();
				}
				break;
			case 'sql':
				rp.host.open(`dwh-sql-buffer-${spid}`, { title: `${msg('Process')} #${spid}` });
				break;
		}
	}

}
